import React, { useState, useEffect, useRef } from 'react';
import Input from "../../components/Input/Input";
import { TOOLBAR_CONTROL_FORCE_H } from "../Table/toolbarControl";

const DebounceInput = ({ customClassName, setSearchValue, placeholder, classes, label, value = '' }) => {
  const [inputValue, setInputValue] = useState(value);
  const debounceRef = useRef(null);

  // Sync with external value (URL changes via browser navigation)
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (newValue) => {
    setSearchValue(newValue);
  };

  const handleDebounceChange = (newValue) => {
    setInputValue(newValue);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // 1500ms read as "search is broken" — nothing happened for a second and a
    // half after the last keystroke. 350ms still coalesces typing.
    debounceRef.current = setTimeout(() => {
      handleChange(newValue);
    }, 350);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  return (
    <Input
      parentClassName={customClassName}
      // The search box is always a toolbar control, never a form field, so it takes
      // the toolbar height rather than Input's larger form default. Forced because
      // Input's own h-14 is in the same Tailwind group — class order would not decide it.
      classes={`p-0 pl-10 ${TOOLBAR_CONTROL_FORCE_H} ${classes}`}
      type="search"
      value={inputValue}
      onChange={(e) => handleDebounceChange(e.target.value)}
      placeholder={placeholder}
      label={label}
    />
  );
};

export default DebounceInput;
